module.exports = __webpack_public_path__ + "img/sobha-2.dc7a8aa.webp";